import { render, staticRenderFns } from "./marquee.vue?vue&type=template&id=45e4c568&lang=pug"
import script from "./marquee.vue?vue&type=script&lang=js"
export * from "./marquee.vue?vue&type=script&lang=js"
import style0 from "./marquee.vue?vue&type=style&index=0&id=45e4c568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports